<template>

    <div class="website::admin-websitepages-index-SparkLineComponent"/>

</template>

<script>

// TODO Render labels as well.
export default {

    props: {
        values: Array,
        maxValue: Number,
    },

    mounted()
    {
        this.initPlugin();
    },

    methods: {
        async initPlugin()
        {
            // Wait for DOM.
            await this.$nextTick();

            // (Re)init Sparkline.
            $(this.$el)
                .sparkline(this.amounts, {
                    type: 'bar',
                    height: 35,
                    barWidth: 5,
                    resize: true,
                    barSpacing: 5,
                    barColor: '#55ce63',
                    chartRangeMax: this.maxValue,
                    tooltipFormatter: this.tooltipFormatter,
                });
        },

        tooltipFormatter(sparkline, options, fields)
        {
            return this.values[fields[0].offset].date + ': ' + fields[0].value;
        }
    },

    watch: {
        'values'()
        {
            this.initPlugin();
        }
    },

    computed: {
        amounts()
        {
            return _.map(this.values, 'amount');
        }
    }

}

</script>